import { Shield, Layers, Sparkles, Timer, FileText, Upload } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { SECTIONS } from "@/data/questions";

export default function Sidebar({ activeSection, onSelectSection, counts }) {
  const location = useLocation();
  return (
    <aside
      data-testid="sidebar"
      className="hidden lg:flex w-72 shrink-0 border-r border-zinc-800 bg-zinc-950 flex-col h-screen sticky top-0 overflow-y-auto"
    >
      <div className="px-6 py-6 border-b border-zinc-800">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-link">
          <div className="w-9 h-9 bg-sky-500 flex items-center justify-center">
            <Shield className="w-5 h-5 text-zinc-950" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display text-lg font-bold leading-none">AIS · ORAL</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-1">
              Préparation jury
            </div>
          </div>
        </Link>
      </div>

      <div className="px-4 py-4 border-b border-zinc-800 space-y-0.5">
        <NavLink to="/" path={location.pathname} icon={Layers} label="Toutes les questions" testid="nav-browse" />
        <NavLink to="/flashcards" path={location.pathname} icon={Sparkles} label="Mode flashcards" testid="nav-flashcards" />
        <NavLink to="/exam" path={location.pathname} icon={Timer} label="Mode examen" testid="nav-exam" />
        <NavLink to="/antiseche" path={location.pathname} icon={FileText} label="Antisèche IA" testid="nav-antiseche" />
        <NavLink to="/import" path={location.pathname} icon={Upload} label="Importer PDF / image" testid="nav-import" />
      </div>

      <div className="px-6 pt-5 pb-2">
        <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">
          Sections
        </div>
      </div>
      <nav className="flex-1 px-2 pb-6 flex flex-col gap-0.5">
        <button
          onClick={() => onSelectSection("all")}
          data-testid="section-filter-all"
          className={`text-left px-4 py-2 text-sm transition-colors ${
            activeSection === "all"
              ? "bg-zinc-900 text-sky-400 border-l-2 border-sky-400"
              : "text-zinc-400 hover:text-zinc-100 hover:bg-zinc-900/60 border-l-2 border-transparent"
          }`}
        >
          <div className="flex items-center justify-between">
            <span>Toutes</span>
            <span className="text-xs text-zinc-600">{counts.all}</span>
          </div>
        </button>
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            data-testid={`section-filter-${s.id}`}
            onClick={() => onSelectSection(s.id)}
            className={`text-left px-4 py-2 text-sm transition-colors ${
              activeSection === s.id
                ? "bg-zinc-900 text-sky-400 border-l-2 border-sky-400"
                : "text-zinc-400 hover:text-zinc-100 hover:bg-zinc-900/60 border-l-2 border-transparent"
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="truncate">{s.short}</span>
              <span className="text-xs text-zinc-600">
                {counts.bySection[s.id] ?? 0}
              </span>
            </div>
          </button>
        ))}
      </nav>

      <div className="px-6 py-5 border-t border-zinc-800 text-[10px] uppercase tracking-[0.25em] text-zinc-600">
        v1 · TP AIS · oral 60 min
      </div>
    </aside>
  );
}

function NavLink({ to, path, icon: Icon, label, testid }) {
  const active = path === to;
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`flex items-center gap-2 px-3 py-2 text-sm transition-colors ${
        active
          ? "bg-zinc-900 text-sky-400 border-l-2 border-sky-400"
          : "text-zinc-400 hover:text-zinc-100 hover:bg-zinc-900/60 border-l-2 border-transparent"
      }`}
    >
      <Icon className="w-4 h-4" />
      <span>{label}</span>
    </Link>
  );
}
